import React, { useState, useEffect } from 'react';
import { getMyAttendance } from '../../api';
import { toast } from 'react-toastify';

const StudentAttendance = () => {
  const [attendance, setAttendance] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [filter, setFilter] = useState('all');

  useEffect(() => { loadAttendance(); }, []);

  const loadAttendance = async () => {
    try {
      const res = await getMyAttendance();
      setAttendance(res.data);
    } catch (err) {
      toast.error('Error loading attendance');
    }
  };

  const getSubjectStats = () => {
    const subjects = {};
    attendance.forEach(a => {
      if (!subjects[a.subject_name]) {
        subjects[a.subject_name] = { present: 0, absent: 0, leave: 0, total: 0 };
      }
      subjects[a.subject_name][a.status]++;
      subjects[a.subject_name].total++;
    });
    return subjects;
  };

  const subjectStats = getSubjectStats();

  const getPercentage = (present, total) => {
    if (total === 0) return 0;
    return ((present / total) * 100).toFixed(1);
  };

  return (
    <div>
      <h3 style={styles.title}>✅ My Attendance</h3>

      {/* Subject wise summary */}
      <div style={styles.summaryGrid}>
        {Object.entries(subjectStats).map(([subject, stats]) => {
          const percentage = getPercentage(stats.present, stats.total);
          return (
            <div key={subject} style={styles.subjectCard}>
              <h4 style={styles.subjectName}>{subject}</h4>
              <div style={styles.statsRow}>
                <span style={styles.presentBadge}>P: {stats.present}</span>
                <span style={styles.absentBadge}>A: {stats.absent}</span>
                <span style={styles.leaveBadge}>L: {stats.leave}</span>
              </div>
              <div style={styles.progressBar}>
                <div style={{
                  ...styles.progressFill,
                  width: `${percentage}%`,
                  background: percentage >= 75 ? '#28a745' : '#dc3545'
                }} />
              </div>
              <p style={{
                ...styles.percentage,
                color: percentage >= 75 ? '#155724' : '#721c24'
              }}>
                {percentage}% Attendance
                {percentage < 75 && ' ⚠️ Low!'}
              </p>
            </div>
          );
        })}
      </div>

      {/* Detailed attendance */}
      <div style={styles.tableCard}>
        <h4 style={styles.tableTitle}>Detailed Attendance Record</h4>
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableHeader}>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Subject</th>
              <th style={styles.th}>Status</th>
            </tr>
          </thead>
          <tbody>
            {attendance.length === 0 && (
              <tr>
                <td colSpan="3" style={styles.empty}>No attendance records!</td>
              </tr>
            )}
            {attendance.map(a => (
              <tr key={a.id} style={styles.tableRow}>
                <td style={styles.td}>
                  {new Date(a.date).toLocaleDateString()}
                </td>
                <td style={styles.td}>{a.subject_name}</td>
                <td style={styles.td}>
                  <span style={{
                    ...styles.statusBadge,
                    background: a.status === 'present' ? '#d4edda' :
                      a.status === 'absent' ? '#f8d7da' : '#fff3cd',
                    color: a.status === 'present' ? '#155724' :
                      a.status === 'absent' ? '#721c24' : '#856404'
                  }}>
                    {a.status === 'present' ? '✅ Present' :
                      a.status === 'absent' ? '❌ Absent' : '🟡 Leave'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  title: { color: '#1a3a5c', marginBottom: '20px' },
  summaryGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '15px', marginBottom: '20px' },
  subjectCard: { background: 'white', borderRadius: '12px', padding: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  subjectName: { color: '#1a3a5c', margin: '0 0 10px', fontSize: '14px' },
  statsRow: { display: 'flex', gap: '8px', marginBottom: '10px' },
  presentBadge: { padding: '3px 8px', background: '#d4edda', color: '#155724', borderRadius: '10px', fontSize: '12px' },
  absentBadge: { padding: '3px 8px', background: '#f8d7da', color: '#721c24', borderRadius: '10px', fontSize: '12px' },
  leaveBadge: { padding: '3px 8px', background: '#fff3cd', color: '#856404', borderRadius: '10px', fontSize: '12px' },
  progressBar: { background: '#e9ecef', borderRadius: '10px', height: '8px', marginBottom: '5px' },
  progressFill: { height: '100%', borderRadius: '10px' },
  percentage: { margin: 0, fontSize: '13px', fontWeight: '600' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  tableTitle: { color: '#1a3a5c', margin: '0', padding: '15px 20px', borderBottom: '1px solid #eee' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHeader: { background: '#1a3a5c' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'left', fontSize: '13px' },
  tableRow: { borderBottom: '1px solid #eee' },
  td: { padding: '12px 15px', fontSize: '13px', color: '#444' },
  empty: { textAlign: 'center', color: '#999', padding: '40px' },
  statusBadge: { padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600' },
};

export default StudentAttendance;